import React from 'react';
import { Spinner, Text } from '@billda/design-system';

interface InvitationProcessingProps {
  isAccepting: boolean;
  organisationName: string;
}

const InvitationProcessing: React.FC<InvitationProcessingProps> = ({
  isAccepting,
  organisationName,
}) => {
  if (!isAccepting) return null;

  return (
    <div className="mx-auto w-full max-w-[600px] px-4">
      <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-surface-overlay">
        <div className="min-w-[300px] rounded-xl border border-border-default bg-surface-default p-8 text-center shadow-xl">
          <div className="mb-4">
            <Spinner size={60} thickness={4} />
          </div>
          <Text as="div" variant="h6" className="mb-2">
            Accepting Invitation
          </Text>
          <Text as="div" variant="body2" color="secondary" className="mb-2">
            Joining <strong>{organisationName}</strong>...
          </Text>
          <Text variant="caption" color="secondary">
            You&apos;ll be redirected automatically once complete.
          </Text>
        </div>
      </div>
    </div>
  );
};

export default InvitationProcessing;
